import { SelectiveListItemStateTokens, } from '@voltmoney/schema';
export const args = {
    title: 'Adarsh Co-Operative Bank',
    imageUrl: 'https://reactnative.dev/img/tiny_logo.png',
    subTitle: 'xxxx 8096',
    state: SelectiveListItemStateTokens.SELECTED,
};
export const argTypes = {
    state: {
        control: 'select',
        options: [
            ...Object.values(SelectiveListItemStateTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
